import { defineStore } from "pinia";

export const useUiVisibilityStore = defineStore({
  id: "uiVisibility",
  state: () => ({
    UI: true,
    ZoomCard: false,
    ButtonNextSection: false,
    ButtonPreviousSection: false,
    TooltipCopyLink: false,
    ForwardArrow: false,
    NavigatorIsReady: false,
    SecondaryMenu: false,
    headless: false,
  }),
  getters: {
    showUI: (state) => state.UI && !state.headless,
    showZoomCard: (state) => state.ZoomCard,
    showTooltipCopyLink: (state) => state.TooltipCopyLink,
    navigatorReady: (state) => state.NavigatorIsReady,
  },
  actions: {
    setShowUI(show: boolean) {
      this.UI = show;
    },
    setShowZoomCard(show: boolean) {
      this.ZoomCard = show;
    },
    setShowTooltipCopyLink(show: boolean) {
      this.TooltipCopyLink = show;
    },
    setNavigatorReady(ready: boolean) {
      this.NavigatorIsReady = ready;
    },
  },
});
